import React from 'react';
import {
  //BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
//import logo from './logo.svg';
import './App.css';

import TimeTable from './components/TimeTable';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<TimeTable />} exact={true} />
        <Route path="/timetable" element={<TimeTable />} exact={true} />
      </Routes>
    </div>
  );
}

export default App;
